const miscPath = '/icons';
export const ICONS = {
  misc: {
    three_dot_menu: `${miscPath}/three-dots.svg`,
  },
};
